import { render, staticRenderFns } from "./ProjectEnabler.vue?vue&type=template&id=225fa9c5&scoped=true"
import script from "./ProjectEnabler.vue?vue&type=script&lang=js"
export * from "./ProjectEnabler.vue?vue&type=script&lang=js"
import style0 from "./ProjectEnabler.vue?vue&type=style&index=0&id=225fa9c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225fa9c5",
  null
  
)

export default component.exports